import { ValidationError } from "./domain.error.js";

export class InvalidPhoneNumberError extends ValidationError {
  constructor(public readonly invalidValue: string) {
    super(
      `Invalid E.164 phone number: '${invalidValue}'. Expected format: +[country code][number] (e.g., +14155551234)`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidPhoneNumberError",
    });
  }
}
